import fetch from 'auth/FetchInterceptor'
import {X_API_KEY} from "../../configs/AppConfig";
import {AUTH_TIPE} from "../../constants/AuthConstant";

const tarifShiftService = {}

tarifShiftService.data = function (token,data='') {
    return fetch({
        url: '/ref/tarif_shift/data',
        method: 'post',
        data: data,
        params: {},
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

tarifShiftService.data_import = function (token,data) {
    return fetch({
        url: '/ref/tarif_shift/data_import',
        method: 'post',
        data: data,
        params: {},
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

tarifShiftService.empty_import = function (token,data) {
    return fetch({
        url: '/ref/tarif_shift/empty_import',
        method: 'post',
        data: data,
        params: {},
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

tarifShiftService.save_import = function (token,data) {
    return fetch({
        url: '/ref/tarif_shift/save_import',
        method: 'post',
        data: data,
        params: {},
        headers:{
            "x-api-key":X_API_KEY,
            "x-admin":localStorage.getItem(AUTH_TIPE)
        }
    })
}

export default tarifShiftService;
